import React from "react";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";

function ContentBox(props) {
    return <div style={{margin: 16}}><Card>
        <CardContent>
            <div>
                {props.children}
            </div>
        </CardContent>
        {props.actions ?
            <CardActions>
                {props.actions}
            </CardActions> : null}
    </Card></div>;
}

export default ContentBox;